import { useMemo } from 'react';
import { useUserRole } from '../context/UserRoleContext';
import {
  formatUserFacingError,
  extractTechnicalMessage,
  logErrorForAdmin,
  logWarnForAdmin,
  logDebugForAdmin,
} from '../utils/userFacingError';

/**
 * Helpers for showing safe messages to end users while preserving technical detail for admins.
 */
export function useUserFacingError() {
  const { isAdmin } = useUserRole();

  return useMemo(
    () => ({
      isAdmin,
      formatError: (error) => formatUserFacingError(error, isAdmin),
      technical: (error) => extractTechnicalMessage(error),
      logError: (label, error) => logErrorForAdmin(isAdmin, label, error),
      logWarn: (label, errorOrMessage) => logWarnForAdmin(isAdmin, label, errorOrMessage),
      logDebug: (...args) => logDebugForAdmin(isAdmin, ...args),
    }),
    [isAdmin]
  );
}
